module.exports = __webpack_public_path__ + "img/img_on_blr.aceeaea1.jpg";